<script>
import preview from './common/preview.vue';
import dragula from 'dragula';
import dragdrop from './common/dragdrop.vue';
import editor from './campaign/editor.vue';
import settings from './campaign/campaignSettings.vue';
import verifyModal from './campaign/verify-modal.vue';
import utility from "../../utility";
import debounce from "debounce";
import {elementsSettingsDefaults, elementsSettingsDefinition} from './settings/settingsDefinition.js';
import moment from "moment";
import toaster from "../common/toaster";
import {widgetSettingsAndPropertiesToQueryString, widgetSettingsAndPropertiesToStructure} from '../../../utils/widget';

export default {
        components: {
            dragdrop,
            editor,
            settings,
            verifyModal,
            preview
        },
        props: [
            'campaign',
            'inline',
            'back_url',
            'add',
            'insertX',
            'insertY',
            'insert_data',
            'parent_layer_limitation',
            'parent_usergroup_limitation',
            'publish_privilege',
            'approve_privilege',
            'stretch',
        ],
        data: function () {
            return {
                t_endless_loop: Lang.langGet("Checking for endless loop. This may take a while."),
                t_endless_loop_fail: Lang.langGet("You are not allowed to add the element, an endless loop was detected:"),
                t_template_link_fail: Lang.langGet("Failed to link template!"),
                t_campaign_link_fail: Lang.langGet("Failed to link campaign!"),
                t_edit_failed_prefix: Lang.langGet("Failed to edit campaign:"),
                saving: false,
                previewing: false,
                creator: false,
                dynamic: false,
                inline_show: true,
                inner_campaign: null,
                dragulaObject: null,
                campaign_state_origin: null,
                campaign_state: null,
                campaign_link_id: null,
                grid: '2cols',
                layout: 'editor-right',
                mode: 'tiles',
                active_element: -1,
                next_active_element: null,
                preview_url: '',
                startDragdropCollapsed: false,
                startSettingsCollapsed: false,
                startDragdropActive: false,
                startSettingsActive: false,
                inner_name: '',

                lineSize: '',
                parentLayerLimitation: [],
                parentUsergroupLimitation: [],
                currentLayerLimitation: [],
                currentUsergroupLimitation: [],
                updatePublish: 0,
                updateApprove: -1,
                dragging: false,

                headerHeight: 56,
                creatorHeaderResizeObserverCloseHandle: () => null,

                t_auto_approve: Lang.langGet("The modified content gets approved in all layers."),
                t_auto_keep_approved: Lang.langGet("Approved state of layer elements is not changed."),
                t_auto_disapprove: Lang.langGet("Layer elements that contain the modified content get disapproved."),
                t_auto_publish: Lang.langGet("Layers that contain the modified content get published to the relevant screens."),
                t_auto_not_publish: Lang.langGet("Layer elements do not get published."),
                windowInfo: {},
                layoutInfo: {},
            }
        },
        computed: {
            creatorStyles: function () {
                let height = (Math.max(this.layoutInfo.minHeight ?? 692, this.windowInfo.contentHeight ?? 692));

                return {
                    height: `${height}px`
                }
            },
            must_convert: function () {
                return this.campaign_state_origin !== this.campaign_state;
            },
            t_in_use: function () {
                return Lang.langGet("The current element is currently being edited by the following persons: :persons", {persons: _.join(this.inner_campaign.activities, ', ')});
            },
        },
        methods: {
            appendDragdropAndSettings: function () {
                let d = document.getElementById('dragdrop-col');
                if (this.mode === 'list') {
                    if (this.grid === '2cols') {
                        if (d) { document.getElementById('dragdrop-settings-col').appendChild(document.getElementById('dragdrop-col')); }
                        document.getElementById('dragdrop-settings-col').appendChild(document.getElementById('settings-col'));
                        document.getElementById('mode-list-container').appendChild(document.getElementById('editor-col'));
                    } else {
                        if (d) { document.getElementById('mode-list-container').appendChild(document.getElementById('dragdrop-col')); }
                        document.getElementById('mode-list-container').appendChild(document.getElementById('settings-col'));
                        document.getElementById('mode-list-container').appendChild(document.getElementById('editor-col'));
                    }
                } else {
                    if (d) { document.getElementById('tiles-dragdrop-settings-row').appendChild(document.getElementById('dragdrop-col')); }
                    document.getElementById('tiles-dragdrop-settings-row').appendChild(document.getElementById('settings-col'));
                    document.getElementById('tiles-editor-row').appendChild(document.getElementById('editor-col'));
                }
            },
            defaultValue: function (type, field, created) {
                if(created && this.inner_campaign) {
                    switch (field) {
                        case 'transition':
                            return this.inner_campaign.transition;
                        case 'transition_length':
                            return this.inner_campaign.transition_length;
                        case 'stretch':
                            return this.stretch;
                    }
                }
                let presetValue = null;
                if(created && this.inner_campaign && this.inner_campaign.presets[type]) {
                    presetValue = this.inner_campaign.presets[type]['campaign'] ? this.inner_campaign.presets[type]['campaign'][field] : null;
                    presetValue = presetValue ? presetValue : (this.inner_campaign.presets[type]['all'] ? this.inner_campaign.presets[type]['all'][field] : null);
                }

                if(presetValue) {
                    return presetValue;
                } else if (type in elementsSettingsDefaults && field in elementsSettingsDefaults[type]) {
                    return elementsSettingsDefaults[type][field];
                } else if ("default" in elementsSettingsDefaults && field in elementsSettingsDefaults["default"]) {
                    return elementsSettingsDefaults["default"][field];
                }
                return "";
            },
            loadDefinitionForType: function (type) {
                let prefix = "c_";
                if (type === undefined) {
                    return;
                }

                let properties = [];
                if (elementsSettingsDefinition[type] !== undefined && elementsSettingsDefinition[prefix + type] !== undefined) {
                    Object.assign(properties, elementsSettingsDefinition[type], elementsSettingsDefinition[prefix + type]);
                } else if (elementsSettingsDefinition[type] !== undefined) {
                    properties = elementsSettingsDefinition[type];
                } else if (elementsSettingsDefinition[prefix + type] !== undefined) {
                    properties = elementsSettingsDefinition[prefix + type];
                }
                return properties;
            },
            getPropertiesForType: function (type) {
                type = type ?? 'base';
                return this.loadDefinitionForType(type);
            },
            title: function () {
                var type = '';
                if (this.dynamic) {
                    type = Lang.langGet("Dynamic Campaign");
                } else {
                    type = Lang.langChoice("Campaign|Campaigns", 1);
                }
                return type + ': ' + this.inner_name;
            },
            setupDragula: function () {
                if (this.dynamic === true) {
                    this.dragulaObject = null;
                } else {
                    this.dragulaObject = dragula([
                        document.querySelector('.dragdrop-content .mediapool-list'),
                        document.querySelector('.dragdrop-content .drag-element-list'),
                        document.querySelector('.dragdrop-content .template-list'),
                        document.querySelector('.dragdrop-content .campaign-list'),
                        document.querySelector('.dragdrop-content .widgets-list'),
                        document.querySelector('.alternative-dropzone'),
                        document.querySelector('.attach-dropzone'),
                        document.querySelector('#editor-canvas')
                    ], {
                        isContainer: function (el) {
                            return false;
                        },
                        moves: function (el, source, handle, sibling) {
                            return source.id !== 'editor-canvas';
                        },
                        accepts: function (el, target, source, sibling) {
                            let elementData = $(el).find('.element-data');
                            let elementType = elementData.data('type'), dropzoneType = target.getAttribute('data-type');
                            let dropzoneTypes = [];
                            if(typeof dropzoneType === 'string') {
                                dropzoneTypes = target.getAttribute('data-type').split('|');
                            }
                            return target.id === 'editor-canvas'
                                || (target.classList.contains('alternative-dropzone') && dropzoneTypes.includes(elementType))
                                || (target.classList.contains('attach-dropzone') && dropzoneTypes.includes(elementType));
                        },
                        copy: true,
                        mirrorContainer: document.body,
                    })

                    this.dragulaObject.on('drop', (el, target, source, sibling) => {
                        let dropping = true;

                        if (!target) {
                            return false;
                        } else {
                            EaseEventBus.fire('settingsActive');
                        }

                        let elementData = $(el).find('.element-data');

                        let type = elementData.data('type') || this.defaultValue(type, 'type', true),
                            id = elementData.data('file-id') || this.defaultValue(type, 'id', true),
                            name = elementData.data('display-name') || this.defaultValue(type, 'name', true),
                            duration = elementData.data('duration') || this.defaultValue(type, 'duration', true),
                            duration_original = elementData.data('duration'),
                            validFrom = elementData.data('valid-from') || this.defaultValue(type, 'valid_from', true),
                            validTo = elementData.data('valid-to') || this.defaultValue(type, 'valid_to', true),
                            state = _.indexOf(['campaign', 'template'], type) !== -1 ? 'link' : this.defaultValue(type, 'state', true),
                            dynamic = (type === 'campaign') ? (elementData.data('campaign-dynamic') || false) : this.defaultValue(type, 'dynamic', true),
                            page_count = _.toString(elementData.data('page-count')) || 0;

                        // "catch" drops to attach List for (Web) Elements
                        if (target.classList.contains('attach-dropzone') ) {
                            const files = this.inner_campaign.elements[this.active_element].linked_files;
                            if (files.length === 0) {
                                this.inner_campaign.elements[this.active_element].linked_files = [{id: id, name: name}];
                            } else if (files.some((element) => element.id === id) === false) {
                                this.inner_campaign.elements[this.active_element].linked_files.push({id: id, name: name});
                            }
                            el.remove();
                            return;
                        }



                        let background_image = '';
                        if (type === 'widget') {
                            background_image = elementData.data('thumbnail') || null;
                        } else {
                            background_image = elementData.data('preview-name') || this.defaultValue(type, 'url', true);
                        }

                        let structure = {
                            id: id,
                            name: name,
                            type: type.replace('placeholder', ''),
                            duration: duration,
                            duration_original: duration_original,
                            background_image: background_image,
                            valid_from_placeholder: validFrom,
                            valid_to_placeholder: validTo,
                            state: state,
                            dynamic: dynamic,
                            page_count: page_count,
                        };

                        if (type == 'widget') {
                            structure = {
                                ...widgetSettingsAndPropertiesToStructure(elementData.data('settings')),
                                query_string: widgetSettingsAndPropertiesToQueryString(elementData.data('settings')),
                                ...structure
                            };
                        }

                        if (type === 'widget' && elementData.data('preview-name')) {
                            structure['index_html'] = elementData.data('preview-name');
                        }

                        if (['picture', 'video', 'pdf', 'ppt', 'template', 'campaign'].includes(type)) {
                            structure.valid_to = '';
                            structure.valid_from = '';
                            structure.valid_to_placeholder = validTo;
                            structure.valid_from_placeholder = validFrom;
                        }

                        let extendedStructures = [structure];
                        this.insertMissingFields(extendedStructures, false, true);
                        structure = extendedStructures[0];

                        if (type === 'template') {
                            let id = elementData.data('template-id') || null;

                            toaster.warning(this.t_endless_loop);
                            dropping = false;

                            axios.post('/endless-loop-content', {
                                project: Laravel.activeProject,
                                search_type: 'campaign',
                                search_id: this.inner_campaign.first_revision_id,
                                search_name: this.inner_campaign.name,
                                start_type: 'template',
                                start_id: id,
                                start_name: name
                            }).then(() => {
                                toastr.clear();

                                axios.post('/content/template/link', {
                                    project: Laravel.activeProject,
                                    id: id
                                }).then((response) => {
                                    id = response.data.data.id;
                                    structure.id = id;
                                    if (target.classList.contains('alternative-dropzone')) {
                                        EaseEventBus.fire('alternativeElementUpdate', {id: id, url: background_image, type: type, name: name});
                                    } else {
                                        EaseEventBus.fire('addElementToCanvas', structure);
                                    }
                                }).catch(() => {
                                    toaster.error(this.t_template_link_fail);
                                });
                            }).catch((error) => {
                                if (error.response.status === 401) {
                                    window.location = '/login';
                                }

                                let escapedPath = $("<div>").text(error.response.data.data.path).html();
                                toastr.clear();
                                toaster.error(this.t_endless_loop_fail + ' ' + escapedPath);
                            });
                        } else if (type === 'campaign') {
                            let id = elementData.data('campaign-id') || null;

                            toaster.warning(this.t_endless_loop);
                            dropping = false;

                            axios.post('/endless-loop-content', {
                                project: Laravel.activeProject,
                                search_type: 'campaign',
                                search_id: this.inner_campaign.first_revision_id,
                                search_name: this.inner_campaign.name,
                                start_type: 'campaign',
                                start_id: id,
                                start_name: name
                            }).then(() => {
                                toastr.clear();

                                axios.post('/content/campaign/link', {
                                    project: Laravel.activeProject,
                                    id: id
                                }).then((response) => {
                                    id = response.data.data.id;
                                    structure.id = id;
                                    if (target.classList.contains('alternative-dropzone')) {
                                        EaseEventBus.fire('alternativeElementUpdate', {id: id, url: background_image, type: type, name: name});
                                    } else {
                                        EaseEventBus.fire('addElementToCanvas', structure);
                                    }
                                }).catch(() => {
                                    toaster.error(this.t_campaign_link_fail);
                                });
                            }).catch((error) => {
                                if (error.response.status === 401) {
                                    window.location = '/login';
                                }

                                let escapedPath = $("<div>").text(error.response.data.data.path).html();
                                toastr.clear();
                                toaster.error(this.t_endless_loop_fail + ' ' + escapedPath);
                            });
                        }

                        if (target.id === 'editor-canvas' && dropping === true && type.indexOf('placeholder') === -1) {
                            EaseEventBus.fire('addElementToCanvas', structure);
                        }

                        if (target.classList.contains('alternative-dropzone') && dropping === true) {
                            EaseEventBus.fire('alternativeElementUpdate', {id: id, url: background_image, type: type, name: name});
                        }

                        if (type.indexOf('placeholder') !== -1) {
                            switch (type) {
                                case 'mediaplaceholder':
                                    this.redirect_url = '/content/mediapool?add=' + type.replace('placeholder', '');
                                    this.updateCampaignWrapper({refresh: false});
                                    break;
                                case 'templateplaceholder':
                                    this.handleTemplateInlineAdd();
                                    break;
                                case 'campaignplaceholder':
                                    this.handleCampaignInlineAdd();
                                    break;
                            }
                        }

                        el.remove();
                    });

                    this.dragulaObject.on('drag', (el, source) => {
                        this.dragging = true
                    })

                    this.dragulaObject.on('dragend', (el) => {
                        this.dragging = false
                    })
                }
            },
            formatDateEnglish(value) {
                if(value) {
                    let savedFormat = 'MM/DD/yyyy';
                    if (value.includes('.')) {
                        savedFormat = 'DD.MM.yyyy';
                    }

                    let date = moment(value, savedFormat);
                    return date.isValid() ? date.format('MM/DD/yyyy') : '';
                } else {
                    return "";
                }
            },
            updateCampaignNoRedirect: function (verified = false, approve=0, publish=0) {
                if (this.creator === true) {
                    if (this.saving !== true) {
                        if (verified === false && this.must_convert === false && this.campaign_link_id !== null) {
                            EaseEventBus.fire('showModal', 'verify-campaign-save');
                        } else {
                            if (this.inline === 'true') {
                                this.redirect_url = this.back_url;
                                this.updateCampaignWrapper({refresh: false, approve: approve, publish: publish});
                            } else {
                                this.updateCampaignWrapper({refresh: true, approve: approve, publish: publish});
                            }
                        }
                    }
                }
            },
            ratio: function () {
                let width = 0, height = 0;
                let resolution = this.inner_campaign.parameters.resolution.split('x');
                width = resolution[0];
                height = resolution[1];
                return width / height;
            },
            previewCampaign: function () {
                if(this.previewing === true) {
                    return;
                }

                this.previewing = true;
                axios.post('/content/preview', {
                    data: this.inner_campaign,
                    type: 'campaign',
                    ratio: this.ratio(),
                    id: this.campaign.id,
                }).then((response) => {
                    this.preview_url = response.data.data.url;
                    EaseEventBus.fire('showContentPreview');
                    EaseEventBus.fire('donePreviewing');
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_preview_failed);
                });
            },
            cancelInlineCampaign: function () {
                this.endActivity();
                window.location = this.back_url;
            },
            updateValidation: function (value) {
                this.creator = value;
            },
            convertParentCampaignLink: function () {
                this.campaign_state = 'copy';
            },
            triggerActivity: function () {
                if (this.inner_campaign !== null) {
                    axios.get('/activity/' + Laravel.activeUser + '/' + this.inner_campaign.first_revision_id + '/campaign')
                        .then(function () {
                        })
                        .catch(function () {
                        });
                }
            },
            endActivity: function () {
                axios.get('/endactivity/' + Laravel.activeUser + '/' + this.inner_campaign.first_revision_id + '/campaign')
                    .then(function () {
                    })
                    .catch(function () {
                    });
            },
            changeModeToTiles: function () {
                EaseEventBus.fire('campaignMode', 'tiles');
                this.grid = '3cols';
            },
            changeModeToList: function () {
                EaseEventBus.fire('campaignMode', 'list');
                this.grid = this.dynamic ? '2cols' : localStorage.getItem('campaigncreator-grid-' + Laravel.activeProject) ?? this.grid;
            },
            removeSelectedElement: function (key) {
                if(this.dynamic) {
                    return;
                }

                EaseEventBus.fire('unsavedChanges', true);
                this.inner_campaign.elements.splice(key, 1);

                if (this.active_element === key) {
                    this.active_element = -1;
                }
            },
            copySelectedElement: function (key) {
                if(this.dynamic) {
                    return;
                }

                let newElement = JSON.parse(JSON.stringify(this.inner_campaign.elements[key]));

                if (_.indexOf(['template', 'campaign'], newElement.type) !== -1) {
                    axios.post('/content/' + newElement.type + '/copy-local', {
                        project: Laravel.activeProject,
                        id: newElement.id
                    }).then((response) => {
                        EaseEventBus.fire('unsavedChanges', true);
                        let newID = response.data;

                        this.$nextTick(() => {
                            newElement.background_image = _.replace(newElement.background_image, newElement.id, newID);
                            newElement.preview = _.replace(newElement.preview, newElement.id, newID);
                            newElement.id = newID;
                            this.inner_campaign.elements.push(newElement);
                        });
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            window.location = '/login';
                        } else if (error.response.status === 403) {
                            toaster.error(this.t_not_enough_privileges);
                        } else {
                            toaster.error(this.t_add_failed);
                        }
                    });
                } else {
                    this.inner_campaign.elements.push(newElement);
                }

                $('#editor-canvas').animate({scrollLeft: 999999}, 1000);
            },
            convertLink: function (data) {
                let id = data.id;
                let type = data.type;
                let key = data.key;

                axios.post('/content/campaign/convert', {
                    id: id,
                    project: Laravel.activeProject,
                    type: type
                }).then(() => {
                    this.inner_campaign.elements[key].state = 'copy';
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    } else if (error.response.status === 403) {
                        toaster.error(this.t_not_enough_privileges);
                    } else if (error.response.status === 422) {
                        let errorString = '';
                        for (let key in error.response.data) {
                            errorString = errorString + error.response.data[key][0] + ' ';
                        }
                        var escapedString = $("<div>").text(errorString).html();
                        toaster.error(escapedString);
                    } else {
                        toaster.error(this.t_link_convert_failed);
                    }
                });
            },
            addElementToCanvas: debounce(function (structure) {
                if (structure.type === 'other') {
                    toaster.error(Lang.langGet("Elements of this type cannot be added."));
                    return;
                }
                EaseEventBus.fire('unsavedChanges', true);

                this.next_active_element = this.inner_campaign.elements.length;

                let wantsLength = _.indexOf(['video', 'campaign', 'template']) !== -1;
                if(isNaN(structure['duration_original']) && wantsLength) {
                    axios.post('/content/element/getelementduration', {
                        type: structure['type'],
                        id: structure['id'],
                        project: Laravel.activeProject,
                    }).then((response) => {
                        structure['duration_original'] = response.data.duration_element;

                        this.inner_campaign.elements.push(structure);
                    }).catch((error) => {
                        this.inner_campaign.elements.push(structure);
                    });
                } else {
                    this.inner_campaign.elements.push(structure);
                }

                if (this.mode === 'tiles') {
                    $('#editor-canvas').animate({scrollLeft: $('#editor-canvas').get(0).scrollWidth}, 400);
                } else {
                    $('#editor-canvas').animate({scrollTop: $('#editor-canvas').get(0).scrollHeight}, 400);
                }
            }, 200),
            updateCampaignWrapper: function (update) {
                if (update.publish && !localStorage.getItem("campaign-autopublish-confirm-" + Laravel.activeProject)) {
                    EaseEventBus.fire('showAutopublishWarning', {data: update, type: 'campaign', task: 'Save'});
                } else {
                    this.updateCampaign(update);
                }
            },
            updateCampaign: function (update) {
                this.saving = true;

                const data = {
                    name: this.inner_campaign.name,
                    project: Laravel.activeProject,
                    campaign: this.inner_campaign,
                    inline: this.inline === 'true',
                    convert: this.must_convert,
                    link_id: this.campaign_link_id,
                    add: this.add,
                    insertX: this.insertX,
                    insertY: this.insertY,
                    approve: update.approve ?? 0,
                    publish: update.publish ?? 0,
                };

                axios.post('/content/campaign/edit/' + this.inner_campaign.id + '/update', data)
                    .then((response) => {
                    EaseEventBus.fire("unsavedChanges", false);
                    if (update.refresh === true) {
                        window.location = '/content/campaign/edit/' + response.data.data.id;
                    } else {
                        axios.post('/content/inline-info/store', {
                            parentType: "campaign",
                            parentLayerLimitation: JSON.stringify(this.currentLayerLimitation),
                            parentUsergroupLimitation: JSON.stringify(this.currentUsergroupLimitation),
                        }).then(() => {
                            if (this.redirect_url === undefined) {
                                window.location = this.back_url;
                            } else {
                                window.location = this.redirect_url;
                            }
                        });
                    }
                }).catch((error) => {
                    this.saving = false;
                    EaseEventBus.fire('doneUpdatingCampaign');

                    if (error.response.status === 401) {
                        window.location = '/login';
                    } else if (error.response.status === 422) {
                        let errorString = this.t_edit_failed_prefix + ' ';

                        for (let key in error.response.data) {
                            errorString = errorString + error.response.data[key][0] + ' ';
                        }

                        let escapedString = $("<div>").text(errorString).html();
                        toaster.error(escapedString);
                    } else {
                        toaster.error(this.t_edit_failed_prefix + ' '+ error.response?.statusText);
                    }
                });
            },
            updateCampaignAndRedirect(data) {
                this.saving = true;
                const target = data.type === 'template' ? 'template' : 'campaign';

                if (target === 'campaign') {
                    this.redirect_url = `/content/${target}/edit-inline/${data.id}/latest`;
                    this.updateCampaignWrapper({refresh: false});
                    return;
                }

                if (data.state === 'link') {
                    axios.post('/content/campaign/convert', {
                        id: data.id,
                        project: Laravel.activeProject,
                        type: data.type
                    }).then(() => {
                        this.redirect_url = `/content/${target}/edit-inline/${data.id}/latest`;
                        this.updateCampaignWrapper({refresh: false});
                    })
                } else {
                    this.redirect_url = `/content/${target}/edit-inline/${data.id}/latest`;
                    this.updateCampaignWrapper({refresh: false});
                }
            },
            alternativeElementUpdate: function (data) {
                this.inner_campaign.elements[this.active_element].alternative_id = data.id;
                this.inner_campaign.elements[this.active_element].alternative_type = data.type;
                this.inner_campaign.elements[this.active_element].alternative_background_image = data.url;
                this.inner_campaign.elements[this.active_element].alternative_name = data.name;

                this.$forceUpdate();
            },
            setStartCollapse: function () {
                let settingsCollapsed = false;
                let dragdropCollapsed = false;
                let settingsActive = true;
                let dragdropActive = false;
                if (this.grid === '2cols') {
                    let savedSettingsCollapsed = localStorage.getItem('campaigncreator-settings-collapsed-' + Laravel.activeProject);
                    let savedDragdropCollapsed = localStorage.getItem('campaigncreator-dragdrop-collapsed-' + Laravel.activeProject);
                    if (savedSettingsCollapsed !== null && savedDragdropCollapsed !== null) {
                        settingsCollapsed = savedSettingsCollapsed === 'true';
                        dragdropCollapsed = savedDragdropCollapsed === 'true';
                    }

                    let savedSettingsActive = localStorage.getItem('campaigncreator-settings-active-' + Laravel.activeProject);
                    if (savedSettingsActive === null) {
                        if (this.inner_campaign.revision_origin === this.inner_campaign.id) {
                            dragdropActive = true;
                            settingsActive = false;
                        }
                    } else {
                        settingsActive = savedSettingsActive === 'true';
                        dragdropActive = !settingsActive;
                    }
                }

                this.startSettingsCollapsed = settingsCollapsed;
                this.startDragdropCollapsed = dragdropCollapsed;
                this.startSettingsActive = settingsActive;
                this.startDragdropActive = dragdropActive;
            },
            processWindowSize: function () {
                let layoutInfo = this.layoutInfo;
                if (layoutInfo) {
                    let w = window.innerWidth;
                    let h = window.innerHeight;

                    let colWidth = (w - 2 * layoutInfo.wrapperLRpadding) / 12;
                    let maxHeight = h - layoutInfo.navBarHeight - layoutInfo.footerHeight;

                    let data = {'colWidth': colWidth, 'contentHeight': maxHeight};
                    this.windowInfo = data;
                    EaseEventBus.fire('windowInfo', data);
                }
            },
            spreadLayoutInfo: function () {
                let colLRpadding = 10, editorPadding = 5;

                let actionButtonsHeight = this.headerHeight;
                let navBarHeight = 50, footerHeight = 39, wrapperTBpadding = 10, wrapperLRpadding = 10 - colLRpadding;

                let minColWidth = 50;
                let minHeight = 300;

                let dragdropNavTabsHeight = 50;

                let settingsTitleHeight = this.headerHeight;

                let data = {
                    'navBarHeight': navBarHeight,
                    'wrapperTBpadding': wrapperTBpadding,
                    'wrapperLRpadding': wrapperLRpadding,
                    'footerHeight': footerHeight,
                    'colLRpadding': colLRpadding,

                    'minColWidth': minColWidth,
                    'minHeight': minHeight,

                    'settingsTitleHeight': settingsTitleHeight,

                    'dragdropNavTabsHeight': dragdropNavTabsHeight,

                    'actionButtonsHeight': actionButtonsHeight,
                    'editorPadding': editorPadding
                };

                this.layoutInfo = data;
                EaseEventBus.fire('layoutInfo', data);
            },
            handleTemplateInlineAdd: function () {
                axios.post('/content/template/inline-add', {
                    project: Laravel.activeProject,
                    name: 'not-in-use',
                    width: 1,
                    height: 1,
                    resolution: this.inner_campaign.parameters.resolution,
                    format: this.inner_campaign.parameters.format
                }).then((response) => {
                    this.redirect_url = '/content/template/edit-inline/' + response.data.data.id + '?add=inline';
                    this.updateCampaignWrapper({refresh: false});
                }).catch(() => {
                    toaster.error(this.t_template_link_fail);
                });
            },
            handleCampaignInlineAdd: function () {
                axios.post('/content/campaign/inline-add', {
                    project: Laravel.activeProject,
                    name: 'not-in-use',
                    width: 1,
                    height: 1,
                    resolution: this.inner_campaign.parameters.resolution,
                    format: this.inner_campaign.parameters.format
                }).then((response) => {
                    this.redirect_url = '/content/campaign/edit-inline/' + response.data.data.id + '?add=inline';
                    this.updateCampaignWrapper({refresh: false});
                }).catch(() => {
                    toaster.error(this.t_template_link_fail);
                });
            },
            insertMissingFields: function (data, isParentCampaign=false, created=false) {
                let structures;
                if (isParentCampaign) {
                    structures = [data];
                } else {
                    structures = data;
                }

                for (let key in Object.keys(structures)) {
                    const structure = structures[key];
                    let from = null, to = null;

                    from = structure.valid_from;
                    to = structure.valid_to;

                    structure.validity = utility.checkValidity(from, to);

                    let properties = this.getPropertiesForType(structure.type);
                    //DEFAULT VALUES
                    for (let [key, def] of Object.entries(properties)) {
                        if (def.computed) {
                            key = def.computed;
                        }

                        let value = (typeof _.get(structure, key) !== 'undefined' && _.get(structure, key) !== null) ? _.get(structure, key) : this.defaultValue(structure.type, key, created);
                        _.set(structure, key, value);
                    }

                    if(created && Object.keys(properties).includes('duration_type')) {
                        if(Object.keys(properties).includes('display_runs'))  {
                            structure['duration_type'] = 2;
                        } else {
                            structure['duration_type'] = 1;
                        }
                    }

                    if(data.type === 'campaign') {
                        structure.dynamic = typeof structure.dynamic !== 'undefined' ? structure.dynamic : this.defaultValue(structure.type, "dynamic", created);
                    }
                }
            },
            cycleUpdatePublish: function () {
                this.updatePublish = (parseInt(this.updatePublish) + 1) % 2;
                localStorage.setItem("campaigncreator-" + (this.inline === 'true' ? 'inline-' : '') + "publish-" + Laravel.activeProject, this.updatePublish);
            },
            cycleUpdateApprove: function () {
                this.updateApprove = (parseInt(this.updateApprove) + 1) % 3;
                this.updateApprove = this.updateApprove === 2 ? -1 : this.updateApprove;
                localStorage.setItem("campaigncreator-" + (this.inline === 'true' ? 'inline-' : '') + "approve-" + Laravel.activeProject, this.updateApprove);
            },
            changeLineSize: function (size) {
                this.lineSize = size;
                localStorage.setItem('campaign-line-size-' + Laravel.activeUser + '.' + Laravel.activeProject, this.lineSize);
            },
        },
        watch: {
            grid: function (val) {
                if (this.dynamic === false) {
                    localStorage.setItem('campaigncreator-grid-' + Laravel.activeProject, val);
                }
                this.setStartCollapse();
                this.appendDragdropAndSettings();
            },
            mode: function () {
                this.appendDragdropAndSettings();
            },
            dynamic: function () {
                if (this.dynamic === true) {
                    this.grid = '2cols';
                } else if (this.mode === 'tiles') {
                    this.grid = '3cols';
                } else {
                    this.grid = localStorage.getItem('campaigncreator-grid-' + Laravel.activeProject) ?? this.grid;
                }
                this.$nextTick(() => {
                    EaseEventBus.fire('reinitializeDragula');
                })
            }
        },
        mounted() {
            this.lineSize = localStorage.getItem('campaign-line-size-' + Laravel.activeUser + '.' + Laravel.activeProject) ?? 'medium';

            if (this.publish_privilege && this.approve_privilege) {
                this.updatePublish = parseInt(localStorage.getItem("campaigncreator-" + (this.inline === 'true' ? 'inline-' : '') + "publish-" + Laravel.activeProject) ?? 1);
            }
            if (this.approve_privilege) {
                this.updateApprove = parseInt(localStorage.getItem("campaigncreator-" + (this.inline === 'true' ? 'inline-' : '') + "approve-" + Laravel.activeProject) ?? 1);
            }

            const campaignJSON = JSON.parse(this.campaign);

            this.dynamic = campaignJSON.dynamic;

            // workaround because type is missing for inline campaigns
            if (this.inline === 'true') campaignJSON.type = 'campaign';

            this.insertMissingFields(campaignJSON.elements);
            this.insertMissingFields(campaignJSON, true);

            if (Object.keys(campaignJSON).length > 0) {
                if (Laravel.switch_off_times === true) {
                    campaignJSON.all_layer_layers = _.remove(JSON.parse(JSON.stringify(campaignJSON.all_layers)), function (o) {
                        return o.nr !== 0;
                    });
                } else {
                    campaignJSON.all_layer_layers = campaignJSON.all_layers;
                }

                var parentLayerLimitation = [];
                var parentUsergroupLimitation = [];
                if(this.parent_layer_limitation) {
                    parentLayerLimitation = JSON.parse(this.parent_layer_limitation);
                }
                if(this.parent_usergroup_limitation) {
                    parentUsergroupLimitation = JSON.parse(this.parent_usergroup_limitation);
                }
                if(parentLayerLimitation.length > 0) {
                    campaignJSON.all_layer_layers = campaignJSON.all_layer_layers.filter(o => parentLayerLimitation.includes(o.value.toString()));
                }
                if(parentUsergroupLimitation.length > 0) {
                    campaignJSON.all_usergroups = campaignJSON.all_usergroups.filter(o => parentUsergroupLimitation.includes(o.value.toString()));
                }
            }

            this.inner_campaign = _.extend({}, this.inner_campaign, campaignJSON);

            this.campaign_link_id = campaignJSON['id_link'];
            let mode = localStorage.getItem('campaigncreator-mode-' + Laravel.activeProject);
            let insertData = JSON.parse(this.insert_data);

            if (mode == null) {
                this.mode = 'tiles';
            } else {
                this.mode = mode;
            }

            this.inline_show = this.inline;
            if (campaignJSON['is_origin'] === true) {
                this.campaign_state = 'original';
                this.campaign_state_origin = 'original';
            } else {
                if (!campaignJSON['origin']) {
                    this.inline_show = false;
                }
                this.campaign_state = 'copy';
                this.campaign_state_origin = 'copy';
            }

            this.setupDragula();

            const localStorageLayoutKey = `campaigncreator-layout-${Laravel.activeProject}`;
            const layout = localStorage.getItem(localStorageLayoutKey);
            this.layout = layout ? layout : 'editor-right';

            EaseEventBus.listen(localStorageLayoutKey, (val) => this.layout = val);

            let grid = this.dynamic ? '2cols' : (this.mode === 'tiles' ? '3cols' : localStorage.getItem('campaigncreator-grid-' + Laravel.activeProject));

            if (grid !== null) {
                this.grid = grid;
            } else {
                if (this.mode === 'tiles') {
                    this.grid = '3cols';
                } else {
                    this.grid = '2cols';
                }
            }
            this.setStartCollapse();
            this.appendDragdropAndSettings();

            if (_.size(insertData) > 0) {
                let type = insertData.type;
                let structures = [{
                    id: insertData.id,
                    name: insertData.name,
                    type: type,
                    background_image: insertData.picture,
                    state: _.indexOf(['campaign', 'template'], type) !== -1 ? 'link' : this.defaultValue(type, 'state'),
                    dynamic: (type === 'campaign') ? (insertData.dynamic || false) : this.defaultValue(type, 'dynamic'),
                }];
                if(insertData.inline) {
                    structures[0].inline = true;
                }
                this.insertMissingFields(structures, false, true);

                if (insertData.x !== '-1' && insertData.y !== '-1') {
                    this.addElementToCanvas(structures[0]);
                }
            }

            if(this.parent_layer_limitation) {
                this.parentLayerLimitation = JSON.parse(this.parent_layer_limitation);
            }
            if(this.parent_usergroup_limitation) {
                this.parentUsergroupLimitation = JSON.parse(this.parent_usergroup_limitation);
            }
            this.currentUsergroupLimitation = this.parentUsergroupLimitation.map(o => o.toString());
            this.currentLayerLimitation = this.parentLayerLimitation.map(o => o.toString());

            EaseEventBus.listen('layersSelectionChanged', (data) => {
                if(data.length > 0) {
                    this.currentLayerLimitation = data;
                } else {
                    this.currentLayerLimitation = this.parentLayerLimitation.map(o => o.toString());
                }
            });
            EaseEventBus.listen('usergroupsSelectionChanged', (data) => {
                if(data.length > 0) {
                    this.currentUsergroupLimitation = data;
                } else {
                    this.currentUsergroupLimitation = this.parentUsergroupLimitation.map(o => o.toString());
                }
            });

            this.inner_name = this.inner_campaign.name;
            EaseEventBus.listen('campaignNameUpdated', (new_name) => {
                this.inner_name = new_name;
            });
            EaseEventBus.listen('settingsCollapsed', (collapsed) => {
                localStorage.setItem('campaigncreator-settings-collapsed-' + Laravel.activeProject, collapsed);
            });
            EaseEventBus.listen('dragdropCollapsed', (collapsed) => {
                localStorage.setItem('campaigncreator-dragdrop-collapsed-' + Laravel.activeProject, collapsed);
            });
            EaseEventBus.listen('settingsActive', () => {
                localStorage.setItem('campaigncreator-settings-active-' + Laravel.activeProject, true);
            });
            EaseEventBus.listen('dragdropActive', () => {
                localStorage.setItem('campaigncreator-settings-active-' + Laravel.activeProject, false);
            });
            EaseEventBus.listen('addElementToCanvas', (data) => {
                this.addElementToCanvas(data);
            });
            EaseEventBus.listen('alternativeElementUpdate', (data) => {
                this.alternativeElementUpdate(data);
            });
            EaseEventBus.listen('copySelectedElement', (data) => {
                this.copySelectedElement(data);
            });
            EaseEventBus.listen('removeSelectedElement', (data) => {
                this.removeSelectedElement(data);
            });
            EaseEventBus.listen('convertLink', (data) => {
                this.convertLink(data);
            });
            EaseEventBus.listen('reinitializeDragula', () => {
                if (this.dragulaObject !== null) {
                    this.dragulaObject.destroy();
                }
                this.setupDragula();
            });
            EaseEventBus.listen('donePreviewing', () => {
                this.previewing = false;
            });
            EaseEventBus.listen('settingsCampaignChange', (data) => {
                this.inner_campaign = data;
            });
            EaseEventBus.listen('changeDynamic', (value) => {
                this.dynamic = value;
            });
            EaseEventBus.listen('saveAsOriginal', () => {
                this.$nextTick(() => {
                    this.updateCampaignNoRedirect(true, this.approve_privilege ? this.updateApprove : -1, (this.publish_privilege && this.approve_privilege) ? this.updatePublish : 0);
                });
            });
            EaseEventBus.listen('saveAsCopy', () => {
                this.campaign_state = 'copy';

                this.$nextTick(() => {
                    this.updateCampaignNoRedirect(this.approve_privilege ? this.updateApprove : -1, (this.publish_privilege && this.approve_privilege) ? this.updatePublish : 0);
                });
            });
            EaseEventBus.listen('updateCampaignAndRedirect', (data) => {
                this.updateCampaignAndRedirect(data);
            });
            EaseEventBus.listen('hidePreview', () => {
                this.preview_url = '';
            });
            EaseEventBus.listen('campaignMode', (mode) => {
                this.mode = mode;
                localStorage.setItem('campaigncreator-mode-' + Laravel.activeProject, mode);
            });
            EaseEventBus.listen('newContent', (media_type) => {
                if (media_type === 'mediaplaceholder') {
                    this.redirect_url = '/content/mediapool?add=media&x=-1&y=-1';
                    this.updateCampaignWrapper({refresh: false});
                } else if (media_type === 'templateplaceholder') {
                    this.handleTemplateInlineAdd();
                } else if (media_type === 'campaignplaceholder') {
                    this.handleCampaignInlineAdd();
                }
            });

            if (this.inline === 'true') {
                $(this.$el).find('.actions').appendTo('#inline-actionbuttons');
            }

            if (_.size(this.inner_campaign.activities) > 0) {
                toaster.warning(this.t_in_use);
            }

            this.triggerActivity();
            setInterval(() => {
                this.triggerActivity();
            }, 45000);
            window.addEventListener('beforeunload', (e) => {
                this.endActivity();
            });
            this.spreadLayoutInfo();
            this.processWindowSize();
            this.$nextTick(() => {
                window.addEventListener('resize', this.processWindowSize);

                if (this.dynamic) {
                    EaseEventBus.fire('dragdropDoesNotExist');
                }
            });

            window.addEventListener('beforeunload', (e) => {
                if(this.unsavedChanges) {
                    e.returnValue = 'Are you sure you want to leave?';
                }
            });

            EaseEventBus.listen("unsavedChanges", (changes) => {
                this.unsavedChanges = changes;
            });

            EaseEventBus.listen("receivedChanges", () => {
                if (this.next_active_element !== null && this.next_active_element >= -1 && this.next_active_element <= this.inner_campaign.elements.length) {
                    this.active_element = this.next_active_element;
                    this.next_active_element = null;
                }
            });

            EaseEventBus.listen('updateProceed', (data) => {
                if (data.type === 'campaign' && data.task === 'Save') {
                    if (data.proceed) {
                        this.updateCampaign(data.data);
                    } else {
                        this.saving = false;
                    }
                }
            });

            const creatorHeaderResizeObserver = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    const contentBoxSize = entry.borderBoxSize[0]
                    this.headerHeight = contentBoxSize.blockSize
                }
                this.spreadLayoutInfo()
            })

            creatorHeaderResizeObserver.observe(this.$refs.creatorHeader)
            this.creatorHeaderResizeObserverCloseHandle = creatorHeaderResizeObserver.unobserve
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.processWindowSize);
            this.creatorHeaderResizeObserverCloseHandle?.()
        }
    }
</script>
